import { PolygraphyProductFormat } from '../../../../../services/exports/Constants';

export default {
  form: {
    name: {
      label: 'Denumește această lucrare de tipărire',
      placeholder: 'Flyer A5 - promoție specială',
    },
    format: {
      label: 'Tip produs',
      placeholder: 'Selectează tipul de produs',
      options: {
        [PolygraphyProductFormat.FlyerA5]: 'Flyer (A5)',
        [PolygraphyProductFormat.FlyerA6]: 'Flyer (A6)',
        [PolygraphyProductFormat.Sticker60x60]: 'Autocolant (60x60mm)',
        [PolygraphyProductFormat.DoorStickerA5]: 'Autocolant ușă (30x30cm)',
      },
    },
    file: {
      label: 'Fișier',
    },
  },
  buttons: {
    upload: 'Fă clic sau trage pentru a încărca fișierul',
    save: 'Salvează',
  },
  toasts: {
    changes_got_saved: 'Modificările au fost salvate!',
  },
};
